'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = T;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _has = require('has');

var _has2 = _interopRequireDefault(_has);

var _airbnbPropTypes = require('airbnb-prop-types');

var _ = require('../');

var _2 = _interopRequireDefault(_);

var _I18nHtmlSafe = require('./I18nHtmlSafe');

var _I18nHtmlSafe2 = _interopRequireDefault(_I18nHtmlSafe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var phraseOrKeyPropType = (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes2['default'].string, 'phrase', 'k');

// Regexes to match html entities
var HTML_ENTITY_REGEX_COMPONENTS = ['&[A-Za-z0-9]{2,};', // named
'&#[0-9]+;', // decimal
'&#x[0-9a-fA-F]+;'];

// Combined into capture group
var HTML_ENTITY_REGEX = new RegExp('(' + String(HTML_ENTITY_REGEX_COMPONENTS.join('|')) + ')', 'g');

/**
 * Use T to print your translation strings, using the PhraseBundle in your local context.
 * You can bind locally-scoped event listeners to your T instance using the `bind` property.
 *
 * Normal usage:
 *   <T k="calsync.google_calendar" />
 *
 * With HTML content tags:
 *   Passing in phrase key:
 *     const link = <a href="/help" />;
 *     // The translation for this key is "Click %{here_start}here%{here_end} please".
 *     <T k="click_here_please" html here={link} />
 *
 *   Passing translated text:
 *     const link = <a href="/help" />;
 *     <T t="Click %{here_start}here%{here_end} please" html here={link} />
 *
 * With HTML non-content tags:
 *   const icon = <i className="icon icon-danger" />;
 *   // The translation for this key is "see this %{icon} later"
 *   <T k="see_this_icon_later" html icon={icon} />
 */

var propTypes = {
  // The translation key.
  k: phraseOrKeyPropType, // eslint-disable-line react/require-default-props

  // A pre-translated string, possibly containing interpolation placeholders.
  t: _propTypes2['default'].string, // eslint-disable-line react/require-default-props

  // A string that will be used to generate a translation key, and as the
  // fallback if no translation is present.
  phrase: phraseOrKeyPropType, // eslint-disable-line react/require-default-props

  // Additional context about the `phrase` prop, used to help translators.
  context: _propTypes2['default'].string, // eslint-disable-line react/require-default-props

  // Whether the phrase contains HTML.
  html: _propTypes2['default'].bool
};

var defaultProps = {
  html: false
};

var FragmentOrSpan = typeof _react2['default'].Fragment === 'undefined' ? 'span' : _react2['default'].Fragment;

function T(_ref) {
  var translationKey = _ref.k,
      t = _ref.t,
      phrase = _ref.phrase,
      context = _ref.context,
      html = _ref.html,
      translationOptions = _objectWithoutProperties(_ref, ['k', 't', 'phrase', 'context', 'html']);

  if (html) {
    // If `smart_count` is present, we need to initially translate the phrase
    // with that value, so Polyglot can determine the proper pluralization
    // form. We pass the rest of the values through to `I18nHtmlSafe` so it can
    // handle them properly.
    var initialTranslationOptions = {};
    if ((0, _has2['default'])(translationOptions, 'smart_count')) {
      initialTranslationOptions.smart_count = translationOptions.smart_count;
    }
    if ((0, _has2['default'])(translationOptions, 'default')) {
      initialTranslationOptions['default'] = translationOptions['default'];
    }

    // HTML entity support
    // Extracts html entity substrings and replaces with placeholder and prop
    // Otherwise, React will display the html entity string literally
    var originalText = t;
    if (!originalText) {
      originalText = phrase ? _2['default'].phrase(phrase, initialTranslationOptions, context) : _2['default'].t(translationKey, initialTranslationOptions);
    }
    var counter = 0;
    var htmlTranslationOptions = Object.assign({}, translationOptions);
    var text = originalText.replace(HTML_ENTITY_REGEX, function (match) {
      var entityProp = 'htmlEntity' + counter;
      counter += 1;
      // Force html rendering of this section
      htmlTranslationOptions[entityProp + '_dangerous_html'] = match;
      return '%{' + entityProp + '}';
    });

    return _react2['default'].createElement(_I18nHtmlSafe2['default'], {
      html: true,
      text: text,
      values: htmlTranslationOptions
    });
  }

  return _react2['default'].createElement(
    FragmentOrSpan,
    null,
    phrase ? _2['default'].phrase(phrase, translationOptions, context) : _2['default'].t(translationKey, translationOptions)
  );
}

T.propTypes = propTypes;
T.defaultProps = defaultProps;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-i18n/T/index.js
// module id = 259
// module chunks = 168707334958949